import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import HPButton from "@/components/common/Button";
import HPInput from "@/components/common/Input";
import type { ScorecardHeadingRow } from "@/models/Scorecard";

interface HeadingRowBuilderProps {
  editingRow?: ScorecardHeadingRow | null;
  onCancel: () => void;
  onSave: (row: ScorecardHeadingRow) => void;
}

const HeadingRowBuilder: React.FC<HeadingRowBuilderProps> = ({
  editingRow,
  onCancel,
  onSave,
}) => {
  const [label, setLabel] = useState(editingRow?.label ?? "");

  const handleSave = () => {
    if (!label.trim()) return;
    onSave({
      id: editingRow?.id ?? crypto.randomUUID(),
      type: "heading",
      label: label.trim(),
    });
  };

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "primary.main",
        borderRadius: 1,
        p: 1.5,
        mt: 1,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
        {editingRow ? "Edit Heading Row" : "Add Heading Row"}
      </Typography>
      <HPInput
        label="Heading Label*"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        placeholder="Section heading"
      />
      <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          <HPButton variant="outlined" size="small" className="w-full" onClick={onCancel}>
            Cancel
          </HPButton>
        </Box>
        <Box sx={{ flex: 1 }}>
          <HPButton
            variant="contained"
            size="small"
            className="w-full"
            onClick={handleSave}
            disabled={!label.trim() || label.trim() === editingRow?.label}
          >
            {editingRow ? "Apply changes" : "Add heading"}
          </HPButton>
        </Box>
      </Box>
    </Box>
  );
};

export default HeadingRowBuilder;
